import React from 'react';

interface FlatVoiceBlockProps {
  isActive: boolean;
}

export const FlatVoiceBlock: React.FC<FlatVoiceBlockProps> = ({isActive}) => {
  return (
    <div className="widget-speaking w-[100%] mb-[10px] rounded-[1023px] p-[1px] flex items-center justify-center">
    <div className="widget-content [cursor:pointer] w-[100%] h-[52px] rounded-[1023px] bg-white flex items-center justify-center gap-[5px]">
       {isActive ? (
        <>
        <span className="w-[2.8px] h-[4.7px] transition-opacity duration-1000 animate-pulse"></span>
        <span className="w-[2.8px] h-[23.3px] transition-opacity duration-1000 animate-pulse"></span>
        <span className="w-[3px] h-[42px] transition-opacity duration-1000 animate-pulse"></span>
        <span className="w-[2.8px] h-[28px] transition-opacity duration-1000 animate-pulse"></span>
        <span className="w-[2.8px] h-[14px] transition-opacity duration-1000 animate-pulse"></span>
        <span className="w-[2.8px] h-[23.3px] transition-opacity duration-1000 animate-pulse"></span>
        <span className="w-[2.8px] h-[4.7px] transition-opacity duration-1000 animate-pulse"></span>
        </>
       ) : (
        <>
        <span className="w-[2.8px] h-[2.8px]"></span>
        <span className="w-[2.8px] h-[2.8px]"></span>
        <span className="w-[2.8px] h-[2.8px]"></span>
        <span className="w-[2.8px] h-[2.8px]"></span>
        <span className="w-[2.8px] h-[2.8px]"></span>
        <span className="w-[2.8px] h-[2.8px]"></span>
        <span className="w-[2.8px] h-[2.8px]"></span>
        </>
       )}
      </div>
    </div>
  );
};

export default FlatVoiceBlock; 